export const BACKEND_API_ENDPOINT = 'https://185.233.186.240:8080/api'
